import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISetSharedOrderPayload } from "../../types/apis/shared-cart";
import { IOrderItem } from "../../types/Order";
import { NewOrderSliceInitialStateInterface } from "../../types/reduxSlices";

const initialState: NewOrderSliceInitialStateInterface = {
  deliveryBy: "",
  orderNote: "",
  orderItems: [],
  selectedQuantities: {},
  orderTotalPrice: 0,
  selectedOrder: null,
  showDeleteOrdersPopup: false,
  showDeletePatientOrderPopup: false,
  selectedRequestTableItems: [],
  selectedOrderWarehouse: null,
  isPreventUserNavigation: false,
  preventUserToLeave: false,
  previewOrderId: 0,
  refereshPendingOrdersTable: false,
  TotalPriceForSelectedItems: 0,
  requestDetailsTableOrderSelectedType: "",
  isOrderRequestTimerActive: false,
  isOrderTimeOutTimerActive: false,
  returnedOrder: null,
  sharedOrder: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    handleGetSelectedOrder: (
      state,
      action: PayloadAction<IOrderItem | null>,
    ) => {
      state.selectedOrder = action.payload;
    },
    handleShowDeleteOrdersPopup: (state, action: PayloadAction<boolean>) => {
      state.showDeleteOrdersPopup = action.payload;
    },
    handleShowDeletePatientOrderPopup: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.showDeletePatientOrderPopup = action.payload;
    },
    handlePreventUserToLeave: (state, action: PayloadAction<boolean>) => {
      state.preventUserToLeave = action.payload;
    },
    handleIsOrderRequestTimerActive: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isOrderRequestTimerActive = action.payload;
    },
    handleIsOrderTimeOutTimerActive: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isOrderTimeOutTimerActive = action.payload;
    },
    handleUpdateSelectedRequestTableItems: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.selectedRequestTableItems = action.payload;
    },
    handleGetSelectedOrderWarehouse: (state, action: PayloadAction<any>) => {
      state.selectedOrderWarehouse = action.payload;
    },
    handleIsPreventUserNavigation: (state, action: PayloadAction<any>) => {
      state.isPreventUserNavigation = action.payload;
    },
    handlePreviewOrderId: (state, action: PayloadAction<any>) => {
      state.previewOrderId = action.payload;
    },
    handleUpdateRequestDetailsTableOrderSelectedType: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.requestDetailsTableOrderSelectedType = action.payload;
    },
    handleRefereshPendingOrdersTableData: (state) => {
      state.refereshPendingOrdersTable = !state.refereshPendingOrdersTable;
    },
    handleSetTotalPriceForSelectedItems: (
      state,
      action: PayloadAction<number>,
    ) => {
      state.TotalPriceForSelectedItems = action.payload;
    },
    handleStoreSelectedQuantities: (state, action: PayloadAction<any>) => {
      state.selectedQuantities = action.payload;
    },
    handleSetReturnedOrderItem: (state, action: PayloadAction<IOrderItem>) => {
      state.returnedOrder = action.payload;
    },
    handleSetSharedOrderItem: (
      state,
      action: PayloadAction<ISetSharedOrderPayload>,
    ) => {
      state.sharedOrder = action.payload;
    },
  },
});

export const {
  handleGetSelectedOrder,
  handleShowDeleteOrdersPopup,
  handleUpdateSelectedRequestTableItems,
  handleGetSelectedOrderWarehouse,
  handleIsPreventUserNavigation,
  handlePreviewOrderId,
  handlePreventUserToLeave,
  handleIsOrderRequestTimerActive,
  handleIsOrderTimeOutTimerActive,
  handleRefereshPendingOrdersTableData,
  handleSetTotalPriceForSelectedItems,
  handleUpdateRequestDetailsTableOrderSelectedType,
  handleStoreSelectedQuantities,
  handleShowDeletePatientOrderPopup,
  handleSetReturnedOrderItem,
  handleSetSharedOrderItem,
} = orderSlice.actions;

export default orderSlice.reducer;
